import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError, BaseResponse } from '@utils/types/shared/base';
import { AdminTranslationTestResult } from '@utils/types/admin';

type AdminTranslationTestResponse = BaseResponse<AdminTranslationTestResult>;

/**
 * Hook to test translation connection (DeepL API key validation)
 *
 * POST /api/admin/settings/translation/test
 *
 * Tests the DeepL API connection and returns status
 */
export const useTestAdminTranslation = () => {
  const testTranslation = async () => {
    const url = `api/admin/settings/translation/test`;
    const response = await Axios.post<AdminTranslationTestResponse>(url);
    return response.data;
  };

  return useMutation<AdminTranslationTestResponse, AxiosError<BaseError>>(
    testTranslation
  );
};
